import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the ConfigurationPaymentStripePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-stripe',
  templateUrl: 'configuration-payment-stripe.html',
})
export class ConfigurationPaymentStripePage {

  loading_stripe: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    private http: HttpClient,
    public alertCtrl: AlertController,
    public analyticsServices: AnalyticsServices) {
    //notificacion de interes sobre el pay
    if (!this.globals.restaurant.connected_acount || this.globals.restaurant.connected_acount == undefined) {
      this.globals.sendIntegrationSlack('PAYMENT METHODS', 'OPEN STRIPE');
    }
  }

  ionViewWillEnter() {
    //check si details_submitted completado
    if (this.globals.restaurant.connected_acount && !this.globals.restaurant.connected_acount_old) {
      this.checkIfAccountDetailsSubmittedCompleted();
    } else {
      this.loading_stripe = true;
    }
  }

  async checkIfAccountDetailsSubmittedCompleted() {
    var account = await this.retrieveStripeAccountDetailsSubmitted();
    if (account['details_submitted'] && !this.globals.restaurant.payment_method_stripe_details_submitted) {
      await this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_stripe_details_submitted': true
      }).then(() => {
        this.globals.restaurant.payment_method_stripe_details_submitted = true;
      });
    }
    this.loading_stripe = true;
  }

  async createConnectedAccount() {
    //case no connected_acount -> create new account
    if (!this.globals.restaurant.connected_acount) {
      var account = await this.createStripeAccountExpress();
      if (account) {
        this.globals.restaurant.connected_acount = account['id'];
      }
    }
    //get link
    var link = await this.createStripeAccountLink();
    //reload
    if (link['url']) {
      if (this.globals.so_mobile) {
        window.location.assign(link['url']);
      } else {
        window.open(link['url']);
      }
    }
  }

  async goToStripeAccount() {
    var link = await this.createAccountLoginLink();
    if (link['loginLink']) {
      if (this.globals.so_mobile) {
        window.location.assign(link['loginLink']);
      } else {
        window.open(link['loginLink'], '_blank');
      }
    }
  }

  async createStripeAccountExpress() {
    try {
      const params = new HttpParams()
        .set('public_key', this.globals.public_key);
      const response_account = this.http.post(this.globals.analytics_path + 'stripe/create/account_express', params, {}).toPromise();
      //trackingPLGPedidos
      this.analyticsServices.trackingExpPedidos('pay_config', this.globals.tracking_exp['pay_config']);
      return response_account;
    } catch (error) {
      // Controla el error aquí
      // Puedes lanzar el error nuevamente o manejarlo de otra manera
      return throwError('Error en la solicitud: ' + error.message);
    }
  }

  async createStripeAccountLink() {
    try {
      const params = new HttpParams()
        .set('account_id', this.globals.restaurant.connected_acount);
      const response_link = this.http.post(this.globals.analytics_path + 'stripe/create/account_link', params, {}).toPromise();
      return response_link;
    } catch (error) {
      // Controla el error aquí
      // Puedes lanzar el error nuevamente o manejarlo de otra manera
      return throwError('Error en la solicitud: ' + error.message);
    }
  }

  async retrieveStripeAccountDetailsSubmitted() {
    try {
      const params = new HttpParams()
        .set('account_id', this.globals.restaurant.connected_acount);
      const response_account_details = this.http.post(this.globals.analytics_path + 'stripe/retrieve/account_details_submitted', params, {}).toPromise();
      return response_account_details;
    } catch (error) {
      // Controla el error aquí
      // Puedes lanzar el error nuevamente o manejarlo de otra manera
      return throwError('Error en la solicitud: ' + error.message);
    }
  }

  async createAccountLoginLink() {
    try {
      const params = new HttpParams()
        .set('account_id', this.globals.restaurant.connected_acount);
      const resposne_login_link = this.http.post(this.globals.analytics_path + 'stripe/create/account_login_link', params, {}).toPromise();
      return resposne_login_link;
    } catch (error) {
      // Controla el error aquí
      // Puedes lanzar el error nuevamente o manejarlo de otra manera
      return throwError('Error en la solicitud: ' + error.message);
    }
  }


  changeStripe(active) {
    if (this.globals.restaurant.connected_acount != '' && this.globals.restaurant.connected_acount != undefined) {
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'payment_method_stripe': active
      }).then(() => {
        this.globals.restaurant.payment_method_stripe = active;
      });
    } else {
      let toast = this.toastCtrl.create({
        message: 'No podemos activar Stripe',
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-stripe/configuration-payment-stripe.ts